<template>
  <ul>
    <li class="leftbar">
      <el-link
        style="color: #409eff"
        href="http://www.mooctest.org"
        target="_blank"
        >{{ $t("leftBar.compWebsite") }}</el-link
      >
    </li>
    <li class="leftbar">
      <el-link
        style="color: #409eff"
        href="http://forum.mooctest.net"
        target="_blank"
        >{{ $t("leftBar.forum") }}</el-link
      >
    </li>
    <li class="leftbar">
      <el-link
        style="color: #409eff"
        href="http://www.mooctest.net/tools"
        target="_blank"
        >{{ $t("leftBar.tool") }}</el-link
      >
    </li>
    <li class="leftbar">
      <el-link
        style="color: #409eff"
        href="http://www.mooctest.net/summer-faq"
        target="_blank"
        >{{ $t("leftBar.compEntrance") }}</el-link
      >
    </li>
    <li class="leftbar">
      <el-link
        style="color: #409eff"
        href="https://element.eleme.io"
        target="_blank"
        >{{ $t("leftBar.help") }}</el-link
      >
    </li>
    <li class="leftbar">
      <el-link
        style="color: #409eff"
        href="https://element.eleme.io"
        target="_blank"
        >{{ $t("leftBar.teacherAuth") }}</el-link
      >
    </li>
  </ul>
</template>
<script>
export default {
  name: "Leftbar",
};
</script>
<style scoped>
.leftbar {
  /* border-bottom: 1px solid rgb(200, 197, 197); */
  height: 50px;
  width: 200px;
  text-align: center;
  line-height: 50px;
}
</style>
